module.exports = __webpack_public_path__ + "img/contentImg7.1978e8f.webp";